import {NodeComponent} from './node.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContextMenuModule} from '../context-menu/context-menu.module';

@NgModule({
    imports: [
        CommonModule,
        ContextMenuModule
    ],
    declarations: [NodeComponent],
    providers: [],
    exports: [NodeComponent],
})

export class NodeModule {
}